export const parsePlugTypes = (plugs) => {
  const types = [];
  const m = plugs.match(/Type\s+([A-G](?:\s*(?:,|&)\s*[A-G])*)/);
  if (m) {
    m[1].split(/[,&]/).forEach((t) => {
      const c = t.trim();
      if (c && !types.includes(c)) types.push(c);
    });
  }
  if (/A\/B/.test(plugs)) ["A", "B"].forEach((t) => !types.includes(t) && types.push(t));
  return types;
};

const Socket = ({ children, label }) => (
  <span className="inline-flex flex-col items-center gap-1" title={`Type ${label} socket`} data-testid={`plug-icon-${label}`}>
    <svg width="46" height="46" viewBox="0 0 48 48" role="img" aria-label={`Type ${label} plug`}>
      <circle cx="24" cy="24" r="20" fill="#FAF7F2" stroke="#1B4D3E" strokeWidth="1.5" />
      {children}
    </svg>
    <span className="font-mono text-[10px] tracking-widest text-pine">TYPE {label}</span>
  </span>
);

const Round = ({ cx, cy, r = 3 }) => <circle cx={cx} cy={cy} r={r} fill="#1B4D3E" />;
const Slot = ({ x, y, w = 3.5, h = 9 }) => <rect x={x} y={y} width={w} height={h} rx="1.5" fill="#1B4D3E" />;

export const PlugIcon = ({ type }) => {
  switch (type) {
    case "A":
      return <Socket label="A"><Slot x={17} y={17} /><Slot x={27.5} y={17} /></Socket>;
    case "B":
      return <Socket label="B"><Slot x={17} y={17} /><Slot x={27.5} y={17} /><Round cx={24} cy={32} r={2.5} /></Socket>;
    case "C":
      return <Socket label="C"><Round cx={17} cy={24} /><Round cx={31} cy={24} /></Socket>;
    case "E":
      return <Socket label="E"><Round cx={17} cy={26} /><Round cx={31} cy={26} /><circle cx="24" cy="15" r="3" fill="none" stroke="#1B4D3E" strokeWidth="2" /></Socket>;
    case "F":
      return <Socket label="F"><Round cx={17} cy={24} /><Round cx={31} cy={24} /><rect x="12" y="9" width="6" height="3" rx="1" fill="#1B4D3E" /><rect x="30" y="36" width="6" height="3" rx="1" fill="#1B4D3E" /></Socket>;
    case "D":
      return <Socket label="D"><Round cx={24} cy={15} r={3.5} /><Round cx={16} cy={31} /><Round cx={32} cy={31} /></Socket>;
    case "G":
      return <Socket label="G"><Slot x={14} y={14} /><Slot x={30.5} y={14} /><rect x="20" y="30" width="8" height="4" rx="1.5" fill="#1B4D3E" /></Socket>;
    default:
      return null;
  }
};
